export default __webpack_public_path__ + "static/media/performance-yellow1.5d4a6215.svg";